import React from 'react';

import { ICandidateDetails } from '@types';
import { candidateSubtitle, isTruthy } from '@utils';
import { RecommendedStar } from 'components/common/RecommendedStar/RecommendedStar';
import { PersonHeading } from './PersonHeading';

interface ICandidateDetailsHeader {
  data?: ICandidateDetails | null;
  variant?: 'page' | 'drawer';
}

export const CandidateDetailsHeader: React.FC<ICandidateDetailsHeader> = ({
  data,
  variant = 'page',
}) => {
  const fullName = data
    ? [data.profile?.firstName, data.profile?.lastName]
        .filter(isTruthy)
        .join(' ')
        .trim() || 'Candidate'
    : '';
  const subtitle = data
    ? candidateSubtitle(data, { withCountry: variant === 'drawer' })
    : '';

  return (
    <PersonHeading
      name={fullName}
      country={data?.profile?.country ?? ''}
      subtitle={subtitle}
      mark={Boolean(data?.isStarred) && <RecommendedStar />}
      variant={variant}
    />
  );
};
